import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { AuthorizationService } from 'app/services';

@Injectable()
export class RoleLocationAdminGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly authorizationService: AuthorizationService) {}

  canActivate(): Observable<boolean> {
    if (this.authorizationService.isLocationAdmin()) {
      return Observable.of(true);
    } else {
      this.router.navigate(['/']);
      return Observable.of(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/role-location-admin.guard.ts